/**
 * #719 — role validation for manage-users.
 *
 * handle_new_user() no longer grants a default role, so every role has to be
 * written explicitly by this function. One definition of "valid", used by both
 * the invite and update-role paths.
 *
 * Deliberately no default role: an invite that names no role is a caller bug,
 * not a reason to guess. Guessing is what caused #719.
 */
export const APP_ROLES = ["super_admin", "admin", "staff", "viewer"] as const;
export type AppRole = (typeof APP_ROLES)[number];

export function isAppRole(value: unknown): value is AppRole {
  return typeof value === "string" && (APP_ROLES as readonly string[]).includes(value);
}
